/**
 * AuthenticationTab Component
 *
 * Displays authentication details for web application seeds.
 * Shows configured authentication methods, credentials, and session handling.
 * Only rendered for seeds with class='webapplication'.
 *
 * @component
 */

import { WebAuthentication } from '@/sections/asset/components/tabs';
import { Seed } from '@/types';

interface AuthenticationTabProps {
  /** The web application seed to display authentication for */
  seed: Seed;
}

/**
 * AuthenticationTab displays web application authentication configuration
 *
 * Wraps the WebAuthentication component from the asset section to show
 * authentication details for web application seeds.
 *
 * @param seed - The seed object (must be class='webapplication')
 */
export function AuthenticationTab({ seed }: AuthenticationTabProps) {
  return <WebAuthentication asset={seed} />;
}
